import Alpine from 'alpinejs';
import 'shop/assets/js/component/shared/newsletter';

(() => {
    window.Alpine = Alpine;

    Alpine.start();
})();
